import { render, staticRenderFns } from "./saveLecture.vue?vue&type=template&id=41ccfa8a&"
import script from "./saveLecture.vue?vue&type=script&lang=js&"
export * from "./saveLecture.vue?vue&type=script&lang=js&"
import style0 from "./saveLecture.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports